export const GREY = "rgba(200, 200, 200, 0.2)";
export const NAVY = "#072448";
export const RED = "#CC2936";
export const ORANGE = "#F5992A";
export const GREEN = "#58b368";
export const BLUE = "#54d2d2";
export const WHITE = "#FAFAFA";
